import React from 'react'
import Classes from './Orders.module.css'
import DropDown from '../../../StatusDropDown/DropDown'
import MoreDropDown from './MoreDropDown'

export default function TableRow({ value, index }) {
    return (
        <>
            <div
                className={`${Classes.customerRow} ${value.status === 'disabled' ? Classes.disabledRow : ''
                    }`}
                key={value._id}
            >
                <div className={`${Classes.customerInfo} ${Classes.colCustomer}`}>
                    <input type='checkbox' />
                </div>
                <div className={`${Classes.spendings} ${Classes.colSpendings}`}>
                    <h5>{value.name}</h5>
                </div>
                <div className={`${Classes.bookings} ${Classes.colBookings}`}>
                    <DropDown
                        selectedValue={value.status}
                        options={["Pending", "Submitted", "Working", "Completed", "Canceled"]}
                        onChange={(val) => value.status = val}
                        isDropDown={true}
                    />
                </div>
                <div className={`${Classes.dateJoined} ${Classes.colDate}`}>
                    <h5>{value.created}</h5>
                </div>
                <div className={`${Classes.disableToggle} ${Classes.colDisable}`}>
                    <MoreDropDown
                        index={index}
                        user={value}
                    />
                </div>
            </div>
        </>
    )
}
